import { useEffect, useState } from 'react';

/** Wall clock that re-renders every `intervalMs` — lets future-OI fades and
 *  scrubber buckets roll over without a page refresh. */
export function useNow(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
